import React from 'react';

const NotFound = () => {
    return (
        <div>
            <h1 className='font-semibold text-3xl'>Not Found</h1>
            <h1 className='font-semibold text-3xl'>404</h1>
        </div>
    );
};

export default NotFound;